// extracted by mini-css-extract-plugin
export var dropdownContainer = "_p0-0";
export var leftAlign = "_p0-4";
export var listItem = "_p0-2";
export var listItemWrapper = "_p0-1";
export var operationText = "_p0-3";